import { render, staticRenderFns } from "./MaterialDonationCollectionListModal.vue?vue&type=template&id=7311ea7d&"
import script from "./MaterialDonationCollectionListModal.vue?vue&type=script&lang=js&"
export * from "./MaterialDonationCollectionListModal.vue?vue&type=script&lang=js&"
import style0 from "./MaterialDonationCollectionListModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports